import React, { useContext, useState } from 'react'
import CardWithText from '../../components/Cards/CardWithText'
import images from '../../utils/images'
import PartnerContext from '../../hooks/PartnerContext'

const PartnerPricing = () => {


  const { country,
    countryLoading,
    checkOutStatus
  } = useContext(PartnerContext)



  const [data, setData] = useState([
    "Free trial",
    "Success fee",
    "Unlimited Access to candidate pool",
    "No. of listings included in package (each listing for 30 days)",
    "Cost per additional listing for 30 days",
    "Cost to extend listing for 30 days",
    "Listing priority",
    "Host Webinars",
    "",
    ""
  ]);


  return (
    <>
      <div className="pricing-plan">
        <section className="pt-5">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4 col-12 co-sm-9 col-lg-11 col-xl-10 col-xxl-9 mx-auto pt-3">
            <div className="w-100 text-center mt-4">
              <span className="fs-3 fw-bold">Pricing plan</span>
              <span className="ms-4 d-block">
                <img
                  src={images.underline}
                  alt="underline"
                  className="img-responsive logo"
                />
              </span>
            </div>

            <div className="col">
              <CardWithText
                cardTitle="Basic"
                cardPrice={country === "India" ? process.env.REACT_APP_PARTNER_BASIC_RUPEES : `${process.env.REACT_APP_PARTNER_BASIC_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1="Yes"
                cardContent_2={country ==="India" ? '₹7500 (or) 5% per enrollment, whichever is higher' : '$100 (or) 5% per enrollment, whichever is higher'}
                cardContent_3="Yes"
                cardContent_4="3"
                cardContent_5={country === "India" ? "₹2500" : "$50"}
                cardContent_6={country === "India" ? "₹2500" : "$50"}
                cardContent_7=""
                cardContent_8=""
                cardContent_9=""
                cardContent_10=""
                cardBtnName={checkOutStatus.paymentStatus === "trialing" && checkOutStatus.productPlan === "Basic" ? "Free" : "Free"}
                plan="Basic"
                planPhase="Partner"
                planKey={country === "India" ? process.env.REACT_APP_PARTNER_BASIC : process.env.REACT_APP_PARTNER_BASIC_US}
                currentPlan={checkOutStatus.paymentStatus === "trialing" || checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Basic"}
                checkOutStatus={checkOutStatus}
                questionArray={data}
              />
            </div>

            <div className="col">
              <CardWithText
                cardTitle="Premium"
                cardPrice={country === "India" ? process.env.REACT_APP_PARTNER_PREMIUM_RUPEES : `$${process.env.REACT_APP_PARTNER_PREMIUM_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1=""
                cardContent_2=""
                cardContent_3="Yes"
                cardContent_4="5"
                cardContent_5={country === "India" ? "₹2500" : "$50"}
                cardContent_6={country === "India" ? "₹2500" : "$50"}
                cardContent_7=""
                cardContent_8="1 webinars per year"
                cardContent_9=""
                cardContent_10=""
                cardBtnName="Coming soon"
                planPhase="Partner"
                plan="Premium"
                planKey={country === "India" ? process.env.REACT_APP_PARTNER_PREMIUM : process.env.REACT_APP_PARTNER_PREMIUM_US}
                currentPlan={checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Premium"}
                checkOutStatus={checkOutStatus}
                questionArray={data}
              />
            </div>

            <div className="col">
              <CardWithText
                cardTitle="Platinum"
                cardPrice={country === "India" ? process.env.REACT_APP_PARTNER_PLATINUM_RUPEES : `$${process.env.REACT_APP_PARTNER_PLATINUM_DOLLARS}`}
                countryLoading={countryLoading}
                cardContent_1=""
                cardContent_2=""
                cardContent_3="Yes"
                cardContent_4="10"
                cardContent_5={country === "India" ? "₹2500" : "$50"}
                cardContent_6={country === "India" ? "₹2500" : "$50"}
                cardContent_7="Listed on top for professionals for up to 1 week"
                cardContent_8="4 webinar per year"
                cardContent_9=""
                cardContent_10=""
                cardBtnName="Coming soon"
                planPhase="Partner"
                plan="Platinum"
                planKey={country === "India" ? process.env.REACT_APP_PARTNER_PLATINUM : process.env.REACT_APP_PARTNER_PLATINUM_US}
                currentPlan={checkOutStatus.paymentStatus === "complete" && checkOutStatus.productPlan === "Platinum"}
                checkOutStatus={checkOutStatus}
                questionArray={data}
              />
            </div>

            <div className="text-center w-100 fw-medium cardCopyRight mt-5">
              <span className="d-block mb-1">
                Copyright &copy; 2024 | Powered by 2nd Careers
              </span>
              <span className="d-block mb-3"><span className="cursorPointer"  onClick={()=> window.open("https://2ndcareers.com/terms-and-conditions/","_blank")}>Terms&nbsp;and&nbsp;conditions
              </span> | <span className="cursorPointer" onClick={()=> window.open("https://2ndcareers.com/privacy-policy/","_blank")}>Privacy policy</span></span>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default PartnerPricing
